var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTickDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.427,
    height: 10.311,
    viewBox: "0 0 13.427 10.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick_icon",
    "data-name": "tick icon",
    transform: "translate(-586.228 -608.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53038",
    "data-name": "Path 53038",
    d: "M18.956,24.911a1,1,0,0,1-.7-.289L14.29,20.657a.991.991,0,0,1,1.4-1.4l3.215,3.215,6.24-7.132a.991.991,0,0,1,1.493,1.3L19.7,24.572a1,1,0,0,1-.714.339h-.032Z",
    transform: "translate(572.5 593.5)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickDark);
export default __webpack_public_path__ + "static/media/icon-tick-dark.bc512e61.svg";
export { ForwardRef as ReactComponent };